package com.flowyride.data.geocoding.photon

/**
 * @param baseUrl Public instance by default; point it to a self-hosted Photon later.
 * @param language One of Photon's supported languages ("default", "en", "de", "fr").
 */
data class PhotonConfig(
    val baseUrl: String = "https://photon.komoot.io",
    val language: String = "fr",
)
